<style lang="scss" scoped>
/deep/ .comp-battery-condition-dialog {
    margin-top: 5vh !important;
    max-width: 520px;
    .el-input-group__append {
        padding: 0 12px;
    }
    .el-input__inner {
        padding: 0 6px;
    }
    .el-form-item__label {
        width: 100%;
        text-align: left;
    }
}
/deep/ .comp-rule-logs-dialog {
    margin-top: 5vh !important;
    width: 80%;
    height: auto;
}
</style>

<template>
  <div class="comp-battery-conditions">
    <el-dialog :title="title" custom-class="c-el-dialog comp-battery-condition-dialog" :visible.sync="showDialog" :before-close="_close" :close-on-click-modal="false" :append-to-body="true">
        <!-- <el-alert class="mrgb10" type="warning" :title="conditionTips" :closable="false" show-icon></el-alert> -->
        <el-form :model="dialogData" :ref="formRefName" size="small">
            <el-row>
                <el-col :xs="24">
                    <el-form-item>
                        <template slot="label">
                            <span class="col_danger mrgr5">*</span>变更规则原因：请写明修改规则的原因
                        </template>
                        <el-input v-model="handleParams.remark" :rows="3" type="textarea" size="medium" placeholder="请输入变更规则原因"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-divider>
                    <span class="col_warning f13">电量规则至少配置两项</span>
                </el-divider>
                <el-col :xs="24" :sm="8">
                    <el-form-item label="换电前电量低于：">
                        <el-input placeholder="范围1-100" type="number" size="medium" v-model="dialogData.beforeMaxPower"
                            :min="1" :max="100">
                            <template slot="append">%</template>
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="8">
                    <el-form-item label="换电后电量高于：">
                        <el-input placeholder="范围1-100" type="number" size="medium" v-model="dialogData.afterMinPower"
                            :min="1" :max="100">
                            <template slot="append">%</template>
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="8">
                    <el-form-item label="换电前后差值：">
                        <el-input placeholder="范围1-100" type="number" size="medium" v-model="dialogData.powerDiff"
                            :min="1" :max="100">
                            <template slot="append">%</template>
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :xs="24">
                    <el-form-item>
                        <template slot="label">
                            <span class="col_danger mrgr5">*</span>确认服务区：此处仅管理员能选择服务区
                        </template>
                        <el-cascader v-model="selectValue" class="c-pw100" size="medium" :disabled="!isSystemConfig"
                            :options="serviceAreas"
                            :props="{ multiple: true, value: 'name', label: 'name', children: 'children' }"
                            collapse-tags
                            clearable></el-cascader>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :xs="24">
                    <el-form-item>
                        <template slot="label">
                            <span class="col_danger mrgr5">*</span>换电时间范围：仅更新该时间范围内的换电记录
                        </template>
                        <el-date-picker class="c-datetime-range" v-model="selectedTime" type="datetimerange" size="medium"
                            @change="changeRuleTime" :default-time="['00:00:00', '23:59:59']" :clearable="false"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            align="right">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <div class="mrgl5 mrgb10">页面传的条件，请确认是否正确（非必填）：</div>
                <el-col :xs="24" :sm="7">
                    <el-form-item>
                        <el-select placeholder="绩效类型" size="medium" filterable disabled
                            clearable v-model="handleParams.flag" @change="_search()">
                            <el-option v-for="t in arrMoveTaskFlag" :key="t.value" :label="t.desc" :value="t.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="9">
                    <el-form-item>
                        <el-input placeholder="员工姓名/手机号" clearable v-model="handleParams.telOrName" size="medium" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="8">
                    <el-form-item>
                        <el-input placeholder="车辆ID" clearable v-model="handleParams.keywords" size="medium" disabled></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer">
            <el-tooltip effect="dark" placement="top-end" :content="toolTip">
                <el-button class="fl" size="small" type="warning" @click="_reset()">恢复默认值</el-button>
            </el-tooltip>
            <el-button class="fl" size="small" type="danger" plain @click="openRuleLogs()">规则变更日志</el-button>
            <el-button size="small" @click="_close()">关闭</el-button>
            <el-button size="small" type="primary" @click="_save()">确定</el-button>
        </span>
    </el-dialog>

    <!-- 规则日志弹窗 -->
    <el-dialog custom-class="c-el-dialog comp-rule-logs-dialog"
        :visible.sync="ruleLogsVisible" :before-close="_closeRule" :close-on-click-modal="false">
        <rule-logs :ref="refRuleLogs"></rule-logs>
    </el-dialog>
  </div>
</template>

<script>
import permission from "@/mixins/permission"
import enumConfigs from "@/mixins/enumConfigs"
import * as funMaintenance from '@/api/maintenance'
import RuleLogs from "../ruleLogs.vue"
export default {
  name: 'compBatteryCondition',
  mixins: [permission, enumConfigs],
  components: { RuleLogs },
  data() {
    return {
        refRuleLogs: "refBatteryConditionToRuleLogs",
        title: "",
        showDialog: false,
        defaultDialogData: {
            beforeMaxPower: null,
            afterMinPower: 95,
            powerDiff: 50
        },
        dialogData: {},
        handleParams: {
            platform: "",
            area: "",
            beginDate: "",
            endDate: "",
            telOrName: "",
            flag: null,
            keywords: "",
            config: {},
            remark: ""
        },
        formRefName: "refBatteryCondition",
        selectedTime: [],
        conditionTips: "",
        toolTip: "恢复默认值",
        selectValue: [],
        serviceAreas: [],
        ruleLogsVisible: false
    }
  },
  methods: {
    async open(params) {
        await this.getServiceAreas()
        await this.getHandelConfigs()
        this.handleParams = { ...params }
        this.selectValue = [[params.platform, params.area]]
        this.selectedTime = [params.beginDate, params.endDate]
        this.title = `【${params.area}】确认换电规则`
        this.conditionTips = `【${params.area}】更新换电数据，以下换电规则需至少配置两项。`
        this.toolTip = `默认值依顺序：${this.defaultDialogData.beforeMaxPower}、${this.defaultDialogData.afterMinPower}、${this.defaultDialogData.powerDiff}`
        let config = window.$util.getLocalStorage("BatteryCondition")
        this.dialogData = config || { ...this.defaultDialogData }
        this.showDialog = true
    },
    changeRuleTime(timeArr) {
        // 格式化时间
        timeArr = timeArr.map(item => {
            return this.getFormatDate(item)
        })
        this.handleParams.beginDate = timeArr[0] || ""
        this.handleParams.endDate = timeArr[1] || ""
    },
    async getServiceAreas() {
        await funMaintenance.GetBatteryChangeAreas({}).then(response => {
            this.serviceAreas = response.map(item => {
                return item.areaInfo
            })
            this.tranceAreaInfo(this.serviceAreas)
        })
    },
    async getHandelConfigs() {
        await funMaintenance.GetBatteryChangeHandleConfig().then(response => {
            this.defaultDialogData = { ...response }
        })
    },
    tranceAreaInfo(areaInfos) {
        // 分组，platform相同的合并到一个数组
        let platformAreas = {}
        areaInfos.forEach(point => {
            if (!platformAreas[point.platform]) {
            platformAreas[point.platform] = []
            }
            platformAreas[point.platform].push(point)
        })
        // 合并到一个数组
        let newAreaInfos = []
        for (let platform in platformAreas) {
            newAreaInfos.push({
                name: platform,
                platform: platform,
                children: platformAreas[platform]
            })
        }
        this.serviceAreas = newAreaInfos
    },
    _reset() {
        this.dialogData = { ...this.defaultDialogData }
    },
    _close() {
        this.showDialog = false
    },
    _save() {
        let config = {
            beforeMaxPower: Number(this.dialogData.beforeMaxPower) || null,
            afterMinPower: Number(this.dialogData.afterMinPower) || null,
            powerDiff: Number(this.dialogData.powerDiff) || null
        }
        // 校验配置项是否至少配置两项
        let validArr = []
        if (config.beforeMaxPower !== null) validArr.push("beforeMaxPower")
        if (config.afterMinPower !== null) validArr.push("afterMinPower")
        if (config.powerDiff !== null) validArr.push("powerDiff")
        if (validArr.length < 2) {
            this.warningMsg("换电规则需至少配置两项")
            return false
        }
        // 校验配置项是否符合范围
        if (config.beforeMaxPower === null) {
            if (config.powerDiff < 1 || config.powerDiff > 100) {
                this.warningMsg("换电前后的差值需在1-100之间")
                return false
            }
            if (config.afterMinPower < 1 || config.afterMinPower > 100) {
                this.warningMsg("换电后剩余电量需在1-100之间")
                return false
            }
            if (config.afterMinPower < config.powerDiff) {
                this.warningMsg("换电后电量不能小于差值")
                return false
            }
        } else if (config.powerDiff === null) {
            if (config.beforeMaxPower < 1 || config.beforeMaxPower > 100) {
                this.warningMsg("换电前剩余电量需在1-100之间")
                return false
            }
            if (config.afterMinPower < 1 || config.afterMinPower > 100) {
                this.warningMsg("换电后剩余电量需在1-100之间")
                return false
            }
            if (config.afterMinPower <= config.beforeMaxPower) {
                this.warningMsg("换电后剩余电量必须大于换电前剩余电量")
                return false
            }
        } else if (config.afterMinPower === null) {
            if (config.beforeMaxPower < 1 || config.beforeMaxPower > 100) {
                this.warningMsg("换电前剩余电量需在1-100之间")
                return false
            }
            if (config.powerDiff < 1 || config.powerDiff > 100) {
                this.warningMsg("换电前后的差值需在1-100之间")
                return false
            }
            if (config.beforeMaxPower + config.powerDiff > 100) {
                this.warningMsg("换电前剩余电量+换电差值不能大于100")
                return false
            }
        } else {
            if (config.beforeMaxPower + config.powerDiff != config.afterMinPower) {
                this.warningMsg("换电前剩余电量+换电差值必须等于换电后剩余电量")
                return false
            }
        }
        // 检查是否输入了变更规则原因
        if (!this.handleParams.remark) {
            this.warningMsg("请输入变更规则原因")
            return false
        }
        this.alert("换电规则变更后，数据不会及时更新，请等待一段时间再去手动查询换电数据!", "温馨提示").then(() => {
            this._confirm()
        })
    },
    _confirm() {
        let commitData = { ...this.handleParams }
        let config = {
            beforeMaxPower: Number(this.dialogData.beforeMaxPower) || null,
            afterMinPower: Number(this.dialogData.afterMinPower) || null,
            powerDiff: Number(this.dialogData.powerDiff) || null
        }
        window.$util.setLocalStorage("BatteryCondition", config)
        if (commitData.flag === "" || commitData.flag == undefined) {
            commitData.flag = null
        }
        commitData.config = JSON.parse(JSON.stringify(config))
        // 检查是否选择了区域
        if (this.selectValue.length <= 0) {
            this.warningMsg("请选择要更新换电的区域!")
            return false
        }
        // 循环处理每个区域
        window.$common.fullLoading()
        for (let i in this.selectValue) {
            ((i) => {
                setTimeout(async () => {
                    await this._handleTask({
                        ...commitData,
                        platform: this.selectValue[i][0],
                        area: this.selectValue[i][1]
                    })
                    if (i >= this.selectValue.length - 1) {
                        window.$common.closeFullLoading()
                        this.$emit("refreshData", true)
                        this._close()
                    }
                }, (i + 1) * 50);
            })(i)
        }
    },
    async _handleTask(params) {
        await funMaintenance.HandleBatteryTask(params)
    },
    openRuleLogs() {
        this.ruleLogsVisible = true
        setTimeout(() => {
            this.$refs[this.refRuleLogs].open({
                handleType: 1
            })
        }, 100);
    },
    _closeRule() {
        this.ruleLogsVisible = false
    }
  }
}
</script>
